import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging, Messaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyB5TC2Q9rhWGKku6FUMwhivuyBvpfpqGwY",
  authDomain: "udd-roomonitor-fcm-staging.firebaseapp.com",
  projectId: "udd-roomonitor-fcm-staging",
  storageBucket: "udd-roomonitor-fcm-staging.firebasestorage.app",
  messagingSenderId: "724018841808",
  appId: "1:724018841808:web:3279fc7f5cfe6237ce36d5",
  measurementId: "G-5VLN9P9FT5",
};

export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);

let messagingInstance: Messaging | null = null;

export function getFirebaseMessaging(): Messaging | null {
  if (typeof window === "undefined") return null;
  if (!("serviceWorker" in navigator)) return null;
  if (!messagingInstance) {
    messagingInstance = getMessaging(firebaseApp);
  }
  return messagingInstance;
}
